<script setup lang="ts">
import { footerMenu, socialLinks, trustImages, contactInfo } from '~/data/footer';
</script>

<template>
  <footer class="bg-gray-50">
    <div 
      class="container flex flex-col lg:flex-row items-center bg-[url('/svg/new/backgrounds/mesh-09.svg')]
        bg-bottom bg-no-repeat lg:bg-size-[100%_auto] gap-10 py-10 lg:gap-18"
    >
      <div class="flex flex-col gap-5 lg:min-w-fit">
        <div class="flex-center flex-col lg:w-fit gap-5">
          <Icon name="nava-icon:navatel-bold" size="64" class="text-primary-600" />
          <span class="h3 text-primary-600">نواتل نیاز هر کسب و کار</span>
        </div>
        <div class="flex gap-4">
          <NuxtLink
            v-for="link in socialLinks"
            :key="link.icon"
            :to="link.path"
            target="_blank"
            class="text-gray-400 hover:text-primary-600 cursor-pointer"
          >
            <Icon :name="link.icon" size="24" />
          </NuxtLink>
        </div>
        <DevicesDesktop class="w-full mt-5 max-w-89">
          <span class="block text-body2-bold mb-2">با ما در تماس باشید</span>
          <div class="w-full flex flex-col gap-2 text-gray-400">
            <div 
              v-for="item in contactInfo"
              :key="item.text"
              class="w-full flex items-center gap-2"
            >
              <Icon :name="item.icon" size="24" class="min-w-6!" />
              <span class="text-body2-semibold">{{ item.text }}</span>
            </div>
          </div>
        </DevicesDesktop>
      </div>
      <DevicesMobile class="w-full">
        <div class="w-full flex flex-col gap-4">
          <AccordionGroup :defaultOpenFirst="false">
            <Accordion v-for="cate in footerMenu" :key="cate.title">
              <template #head="{ isOpen, toggleAccordion }">
                  <div 
                      class="w-fit p-2 flex items-center gap-4"
                      :class="isOpen && 'text-primary-500'"
                      @click="toggleAccordion"
                  >
                      <span class="text-body1-semibold">{{ cate.title }}</span>
                      <Icon 
                          name="solar:alt-arrow-down-linear" 
                          size="20" 
                          class="transition-transform duration-300" 
                          :class="isOpen && '-rotate-180'"
                      />
                  </div>
              </template>
              <template #body>
                <div class="w-full flex flex-col gap-3">
                    <NuxtLink
                        v-for="link in cate.items"
                        :key="link.title"
                        :to="link.path" 
                        :target="link?.targetBlank ? '_blank' : undefined"
                        class="flex items-center gap-2 px-4 cursor-pointer select-none text-gray-500 
                          hover:text-primary-600 text-body2-semibold"
                    >
                      {{ link.title }}
                    </NuxtLink>
                </div>
              </template>
            </Accordion>
          </AccordionGroup>
        </div>
        <div class="mt-10">
          <span class="block text-body2-bold mb-2">با ما در تماس باشید</span>
          <div class="w-full flex flex-col gap-2 text-gray-400">
            <div 
              v-for="item in contactInfo"
              :key="item.text"
              class="w-full flex items-center gap-2"
            >
              <Icon :name="item.icon" size="24" class="min-w-6!" />
              <span class="text-body2-semibold">{{ item.text }}</span>
            </div>
          </div>
        </div>
      </DevicesMobile>
      
      <DevicesDesktop class="w-full">
        <div class="w-full flex justify-center gap-20 2xl:gap-30">
          <div
            v-for="cate in footerMenu" 
            :key="cate.title"
          >
            <span class="block text-body1-semibold mb-3">{{ cate.title }}</span>
            <div class="flex flex-col gap-3">
              <NuxtLink
                  v-for="link in cate.items"
                  :key="link.title"
                  :to="link.path" 
                  :target="link?.targetBlank ? '_blank' : undefined"
                  class="flex items-center gap-2 px-4 cursor-pointer select-none text-gray-500 
                    hover:text-primary-600 text-body2-semibold"
              >
                {{ link.title }}
              </NuxtLink>
            </div>
          </div>
        </div>
      </DevicesDesktop>
    </div>
    <div class="w-full bg-gray-100 border-t border-gray-200 py-4">
      <div class="w-full container">
        <div class="w-full flex-center flex-col gap-6 lg:flex-row lg:justify-between! lg:px-40">
          <div class="flex-center gap-5 order-1 lg:order-2">
            <NuxtLink
              v-for="link in trustImages"
              :to="link.path"
              target="_blank"
              no-rel
            >
              <NuxtImg
                :src="link.img"
                :alt="link.title"
                width="56"
                heigh="56"
                class="object-cover w-10 h-10 lg:w-14 lg:h-14"
                loading="lazy"
              />
            </NuxtLink>
          </div>
          <div class="flex-center flex-col gap-2 lg:items-start! order-2 lg:order-1">
            <span class="block text-center text-body2-semibold lg:text-start text-gray-500">یک محصول برای تمام قابلیت ها</span>
            <span class="block text-center text-caption lg:text-start text-gray-400">تمام حقوق مادی و معنوی متعلق به نواتل، تنها سرویس یکپارچه ابری (UCaaS) در ایران می باشد.</span>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
